import { AlertProvider } from "../../../hooks/useAlert"
import { AbuseReportLink } from "../AbuseReportLink"

type AbuseLinkSectionProps = {
    roomName: string
    isCurrentUserRoomOwner?: boolean
}

export function AbuseLinkSection(props: AbuseLinkSectionProps) {
    return (
        <AlertProvider>
            <AbuseReportLink
                roomName={props.roomName}
                isCurrentUserRoomOwner={props?.isCurrentUserRoomOwner}
            />
        </AlertProvider>
    )
}
